<template>
  <div class="outer-wrapper">
    <div class="inner-wrapper">
      <slot name="content"></slot>
    </div>
  </div>
</template>

<script>
  export default{
    name: 'card-view',
    data () {
      return {};
    }
  };
</script>

<style scoped lang="scss" type="text/scss" rel="stylesheet/scss">
  @import "../assets/scss/base.scss";

  $commonWhite: #fff5d7;
  $topColor: #e6c590;
  $bottomColor: #ddb375;
  .outer-wrapper {
    width: 100%;
    padding: px2rem(8) px2rem(6) px2rem(9) px2rem(6);
    background-color: $commonWhite;
    margin-top: px2rem(10);
    border-bottom: px2rem(4) solid #d1c088;
    border-left: px2rem(2) solid #cdb679;
    border-right: px2rem(2) solid #cdb679;
    border-radius: px2rem(15);

    .inner-wrapper {
      border-bottom: px2rem(2) solid #c3934e;
      border-left: px2rem(1) solid #bc8d47;
      border-right: px2rem(1) solid #bc8d47;
      font-size: 0;
      margin:  0 auto;
      border-radius: px2rem(10);
      width: 99%;
      @include line-gradient-top-to-bottom($topColor, $bottomColor);
      box-shadow: px2rem(-1) px2rem(1) px2rem(4) #817a68;
    }
  }
</style>



// WEBPACK FOOTER //
// CardView.vue?0d4c5f08